<div class="d-flex p-6">
  <!-- Notes List Section -->
  <div>
    <div class="container" [ngStyle]="{ height: notes.length === 0 ? 'auto' : '470px' }">
      <h2 class="mb-4">Prescription Notes</h2>
      <label *ngIf="notes.length === 0 && !loading"> No prescription notes!</label>

      <div
        *ngFor="let note of notes; let i = index"
        class="p-4 border shadow-sm d-flex justify-content-between cursor-pointer"
        (click)="selectNote(i)"
        matTooltip="Select Note"
        [class.selected]="i === selectedNoteIndex"
      >
        <div>
          <div>
            <p>{{ note.note }}</p>
          </div>

          <div class="text-sm mt-2">
            <p><strong>Author:</strong> {{ note.createdBy }}</p>
            <p><strong>Date:</strong> {{ note.createdDate }}</p>
          </div>
        </div>

        <div
          class="cursor-pointer"
          (click)="pinNote(i); $event.stopPropagation()"
          [ngClass]="{ pinned: note.pinned }"
        >
          <span
            inlineSVG="assets/media/svg/icons/General/pinn.svg"
            class="icon-pin"
            [ngClass]="{ pinned: note.pinned }"
          ></span>
        </div>
      </div>
    </div>
    <ng-template ngxPermissionsOnly="canAddPrescriptionNote">
      <button
        *ngIf="!viewPrescriptionNote"
        (click)="addNewNote()"
        class="btn btn-primary py-2 mt-4"
      >
        Add note
      </button>
    </ng-template>
  </div>

  <div *ngIf="isAddingNew || selectedNoteIndex !== null" class="pl-6 d-flex flex-column">
    <div class="p-6 shadow-md">
      <h3 *ngIf="isAddingNew && selectedNoteIndex == null">Add New Note</h3>

      <h3 *ngIf="!viewPrescriptionNote && !isAddingNew && selectedNoteIndex !== null">
        View/Edit Note
      </h3>
      <h3 *ngIf="viewPrescriptionNote && !isAddingNew && selectedNoteIndex !== null">View Note</h3>

      <div class="d-flex">
        <div class="d-flex flex-column align-items-start ks-w-100">
          <label class="block mb-2">Note Content</label>
          <textarea
            class="w-100"
            [(ngModel)]="currentNote.note"
            rows="17"
            [readonly]="!isAddingNew && selectedNoteIndex !== null"
          ></textarea>
        </div>
      </div>
      <div class="pin-switch">
        <span>Show Note</span>

        <!-- Editable Mode -->
        <ng-template ngxPermissionsOnly="canEditPrescriptionNote">
          <span
            (click)="togglePin()"
            inlineSVG="assets/media/svg/icons/General/pin-{{
              currentNote.active ? 'on' : 'off'
            }}.svg"
            class="pin-icon"
            [ngClass]="{ 'active-pin': currentNote.active, 'inactive-pin': !currentNote.active }"
          >
          </span>
        </ng-template>

        <!-- View-Only Mode -->
        <ng-template ngxPermissionsExcept="canEditPrescriptionNote">
          <span
            inlineSVG="assets/media/svg/icons/General/pin-{{
              currentNote.active ? 'on' : 'off'
            }}.svg"
            class="pin-icon display-only"
            [ngClass]="{ 'active-pin': currentNote.active, 'inactive-pin': !currentNote.active }"
          >
          </span>
        </ng-template>
      </div>
      <div class="d-flex justify-content-end mt-6 note-button">
        <ng-template ngxPermissionsOnly="canEditPrescriptionNote">
          <button
            *ngIf="!viewPrescriptionNote"
            (click)="deleteNote()"
            class="btn text-danger border-danger"
          >
            Delete Note
          </button>
        </ng-template>
        <ng-template ngxPermissionsOnly="canEditPrescriptionNote">
          <button
            *ngIf="!viewPrescriptionNote && !isAddingNew && selectedNoteIndex !== null"
            (click)="isAddingNew = true"
            class="btn btn-primary"
          >
            Edit Note
          </button>
        </ng-template>
        <button
          *ngIf="(!viewPrescriptionNote && isAddingNew) || selectedNoteIndex === null"
          (click)="saveNote()"
          class="btn btn-primary"
        >
          Save Note
        </button>
      </div>
    </div>
  </div>
</div>
